import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { I18nService } from '@services/i18n.service';

export const i18nInitGuard: CanActivateFn = async () => {
	const i18n = inject(I18nService);
	await i18n.ensureInitialized();
	return true; // sblocca il match solo dopo che i18n è pronto
};
